export const validateEmail = (message = "Invalid email address") => {
  return value => {
    const emailPattern = /^[^\s@]+@[^\s@]{2,}\.[^\s@]{2,}$/;
    if (!value) {
      return message
    }
    if (!value.match(emailPattern)) {
      return message
    }
    return true
  }
}

export const isAtLeast8Chars = value => {
  console.log("at least 8", value)
  return value.length >= 8 ? true : "Must be at least 8 characters"
}

export const hasNumber = value => {
  return /[0-9]/.test(value) ? true : "Must include a number"
}

export const hasSymbol = value => {
  return /[!@#$%^&*()-_+=]/.test(value)
    ? true
    : "Must include a symbol (!@#$%^&*()-_+=)"
}

export const hasUpperCase = value => {
  return /[A-Z]/.test(value) ? true : "Must include an uppercase letter"
}

export const hasLowerCase = value => {
  return /[a-z]/.test(value) ? true : "Must include a lowercase letter"
}

export const required = (message = "This field is required") => {
  return value => {
    if (value?.length > 0 || value instanceof Date || typeof value == "number")
      return true
    return message
  }
}

export const isChecked = (message = "You must agree to proceed") => {
  return value => {
    if (!value) return message
    return true
  }
}

export const validatePhoneNumber = (message = "Invalid phone number") => {
  return value => {
    const cleanedValue = value.replace(/[^\d\s]/g, "")

    const hasSpaceBetweenNumbers = /\d\s\d/.test(cleanedValue)

    if (!cleanedValue || !hasSpaceBetweenNumbers) {
      return message
    }

    return true
  }
}
